overlayClose();


// localization
function localization() {
  if (window.ISLocalization) {
    const locations = window.ISLocalization.countries;
    const block = document.querySelector('.localization-drawer');
    if (block) {
      if (!Shopify.designMode) {
        let countryIso, countryName;
        if (!localStorage.getItem('ISLangSet')) {
          fetch('https://api.ipgeolocation.io/ipgeo?apiKey=950634d726c143b983585fb23f7b8b72', {
            headers: {
              "Content-Type": "application/json",
            },
          })
          .then(res => res.json())
          .then(data => {
            // console.log(data);
            countryIso = data.country_code2;
            countryName = data.country_name;
            localStorage.setItem('ISLangSet', countryIso);
            checkLocations(locations, countryIso);
          })
        } else {
          // countryIso = sessionStorage.getItem('ISLangSet');
          // countryName = sessionStorage.getItem('ISLangFlag');
          // checkLocations(locations, countryIso, countryName);
        }

        function checkLocations(locations, countryIso) {
          locations.forEach(location => {
            // console.log(location);
            if (location.iso === countryIso && location.iso != window.ISLocalization.currentLocale) {
              const langPart = location.link != '' ? location.link : '' ;
              const urlString = location.url + '/' + langPart + location.suffix;
              if (location.redirect === 'true') {
                window.location.href = urlString;
              } else {
                show(block);
                show(block.querySelector('.locale-detection'));
                block.querySelector('.locale-detection').innerHTML = location.detection_message;
                triggerOverlay();
                // console.log(location);
              }
            }
          })
        }
      }
    
      const countrySelector = block.querySelector('[data-target="countrySelector"]');
      const countryBlock = block.querySelector('#countrySelector');
      const langSelector = block.querySelector('[data-target="languageSelector"]');
      const langBlock = block.querySelector('#languageSelector');
      const selectors = block.querySelectorAll('.select-button');
      const countries = block.querySelectorAll('[data-type="countrySelectorButton"');
      const langs = block.querySelectorAll('[data-type="languageSelectorButton"]');
      const close = block.querySelector('.close');
      close.addEventListener('click', function() {
        hide(block);
        hide(block.querySelector('.locale-detection'));
        triggerOverlay();
      })
      selectors.forEach(selector => {
        selector.addEventListener('click', function() {
          const target = block.querySelector(`#${selector.dataset.target}`);
          if (selector.classList.contains('active')) {
            hide(selector);
            hide(selector.nextElementSibling);
          } else {
            selectors.forEach(e => {
              hide(e);
              hide(e.nextElementSibling);
            })
            show(selector.nextElementSibling);
            show(this);
          }
        })
      })
      let url = '';
      countries.forEach(country => {
        country.addEventListener('click', function() {
          selectors.forEach(e => {
            hide(e);
            hide(e.nextElementSibling);
          })
          countrySelector.querySelector('.country-title').innerHTML = country.innerHTML;
          countrySelector.dataset.url = country.dataset.countryUrl;
          countrySelector.dataset.suffix = country.dataset.countrySuffix;
          countrySelector.dataset.defaultLocale = country.dataset.defaultLocale;
          // clean langs
          langBlock.innerHTML = '';
          const wrapper = document.createElement('div');
          wrapper.classList.add('selector-target-wrapper');
          langBlock.appendChild(wrapper);
          // get langs
          const countryObject = window.ISLocalization.countries.find(obj => obj.iso === country.dataset.countryIso);
          // build langs
          countryObject.langs.forEach((lang, index) => {
            wrapper.innerHTML += `
            <button data-type="languageSelectorButton" data-iso="${lang.iso}" class="button large with-icon icon-left secondary-white">
              <span class="country-flags country-flags--${lang.countryCode.toUpperCase()}"></span>
              ${lang.name}
            </button>
            `;
          })
          // console.log(langBlock);
          langSelector.querySelector('.lang-title').innerHTML = `
            <span class="country-flags country-flags--${countryObject.default.country_code.toUpperCase()}"></span>
            <span class="country-text">${countryObject.default.title}</span>
          `;
          langSelector.dataset.iso = countryObject.default.iso_code;
        })
      })
      window.addEventListener('click', function(evt) {
        if (evt.target.dataset.type === 'languageSelectorButton') {
          langSelector.querySelector('.lang-title').innerHTML = evt.target.innerHTML;
          langSelector.dataset.iso = evt.target.dataset.iso;
          selectors.forEach(e => {
            hide(e);
            hide(e.nextElementSibling);
          })
        }
        if (evt.target.dataset.type === 'langSwitcher') {
          show(block);
          triggerOverlay();
        }
      })
      const submit = block.querySelector('.locale-submit-button');
      submit.addEventListener('click', function() {
        let url, currentPath;
        const path = window.ISLocalization.currentPath + '/';
        if (countrySelector.dataset.url === window.ISLocalization.origin) {
          currentPath = Shopify.routes.root === '/' ? window.ISLocalization.currentPath : path.replace(Shopify.routes.root, '/');
        } else {
          currentPath = '/' + path.replace(Shopify.routes.root, '/');
        }
        
        currentPath = countrySelector.dataset.suffix + currentPath;
        if (langSelector.dataset.iso === countrySelector.dataset.defaultLocale && !countrySelector.dataset.suffix) {
          currentPath = currentPath;
        } else {
          currentPath = '/' + langSelector.dataset.iso + currentPath;
        }

        currentPath = currentPath.replace('//', '/').replace('//', '/');
        url = countrySelector.dataset.url + currentPath;
        
        window.location.href = url;

      })
    }
  }
}

window.addEventListener('DOMContentLoaded', function() {
  document.querySelector('body').style.opacity = 1;
  localization();
  header();
  heroSlider();
  marquee();
  medals();
  featuredBlog();
  productSliders();
  productFeatures();
  productInstructions();
  productVideos();
  productNav();
  mainAccordion();
  titleGsap();
  textAppear();
  fixedVideo();
  smoothScroll('play');
  mapSection();
  footerAccordion();
  sectionProductList();
  sectionArticle();
  collectionVideoBanner();
  collectionFilters();
  cartDrawer();
  consultationDrawer();
  marketDrawers();
  productMobileDrawer();
  imageGallery();
  awardsList();
  slidingCards();
  predictiveSearch();
  // getAllLangsInstructions();
  recentlyViewed();
  sectionVideos();
  sectionSliderText();
  productGiftSelect();
  bundles();
  pageBundles();
  storiesSlider();
  dynamicDrawer();
  specificationDrawer();
  hotPoints();
  actionsSection();
  sidebarBundle();
  seoText();
})

function seoText() {
  const blocks = document.querySelectorAll('.ks-seo-text');
  if (blocks.length > 0) {
    blocks.forEach(block => {
      const hideWrapper = block.querySelector('.hide-wrapper');
      const button = block.querySelector('.inline-button');
      button.addEventListener('click', function() {
        show(hideWrapper);
        hideWrapper.style.maxHeight = hideWrapper.scrollHeight + "px";
        button.style.display = 'none';
      })
    })
  }
}

function actionsSection() {
  const sections = document.querySelectorAll('.section-actions');
  
  if (sections.length > 0) {
    sections.forEach(section => {

      // nav

      const nav = section.querySelectorAll('.collection-buttons button');
      
      if (nav.length > 0) {
        nav.forEach(btn => {
          btn.addEventListener('click', function() {
            if (!btn.classList.contains('active')) {
              const target = section.querySelector(`.section-actions_content [data-target="${btn.dataset.target}"]`);
              nav.forEach(b => hide(b))
              collections.forEach(c => hide(c));
              // hide(activeBtn);
              // hide(active);
              show(target);
              show(btn);
              // console.log(target);
            }
          })
        })
      }
      

      // swiperjs
      const collections = section.querySelectorAll('.collection-content');
      collections.forEach(collection => {
        const slider = collection.querySelector('swiper-container');
        const swiperParams = {
          autoplay: {
            delay: slider.dataset.delay * 1000,
            disableOnInteraction: false,
          },
          // effect: 'cube',
          // grabCursor: true,
          // cubeEffect: {
          //   shadow: false,      
          //   slideShadows: false,
          //   shadowOffset: 0,
          //   shadowScale: 0
          // },
          slidesPerView: 1,
          pagination: {
            el: collection.querySelector('.swiper-pagination'),
            clickable: true,
            renderBullet: function (index, className) {
                return `<span class="${className}"><span class="progress-bar"></span></span>`;
            }
          },
          on: {
            init: function () {
                
                const activeProgress = collection.querySelector('.swiper-pagination .swiper-pagination-bullet-active .progress-bar');
                if (activeProgress) {
                    activeProgress.style.animation = `progressAnimation ${slider.dataset.delay}s linear forwards`;
                }
            },
            slideChangeTransitionStart: function () {
                
              collection.querySelectorAll('.swiper-pagination .progress-bar').forEach(pb => {
                    pb.style.animation = 'none';
                    
                    void pb.offsetWidth;
                });
                
                const activeProgress = collection.querySelector('.swiper-pagination .swiper-pagination-bullet-active .progress-bar');
                if (activeProgress) {
                    activeProgress.style.animation = `progressAnimation ${slider.dataset.delay}s linear forwards`;
                }
            }
         }
        };
        Object.assign(slider, swiperParams);
        slider.initialize();
      })
      
    })
  }
}

function hotPoints() {
  const block = document.querySelector('.product-hotpoints');
  if (block) {
    const points = block.querySelectorAll('.hot-point');
    const mobilePopups = block.querySelectorAll('.mobile-dsk-point');
    points.forEach((point, index) => {
      
      point.addEventListener('click', () => {
        if (window.innerWidth > 767) {
          const others = Array.from(points).filter(i => i !== point);
          others.forEach(o => {
            hide(o)
          });
          toggle(point);
        } else {
          const currentPopup = mobilePopups[index];
          const otherPopups = Array.from(mobilePopups).filter(i => i !== currentPopup);
          otherPopups.forEach(o => hide(o));
          toggle(currentPopup);
        }
      })
    })
    // refresh on click outside or close
    window.addEventListener('click', (e) => {
      if (!e.target.closest('.hot-point')) {
        if (e.target.closest('.product-hotpoints')) {
          e.target.closest('.close') || !e.target.closest('.dsk-point') ? hide(block.querySelector('.active')) : null;
        }
      }
    })
  }
}

function storiesSlider() {
  const blocks = document.querySelectorAll('.section-stories');
  if (blocks.length > 0) {
    blocks.forEach(block => {
      const slider = block.querySelector('.story-slider');
      if (slider) {
        const swiperParams = {
          delay: slider.dataset.delay * 1000,
          navigation: {
            nextEl: block.querySelector('.next'),
            prevEl: block.querySelector('.prev'),
          },
          pagination: {
            el: block.querySelector('progress-bar'),
            type: 'progressbar',
          },
        };
        Object.assign(slider, swiperParams);
        slider.initialize();
      }
    })
  }
}

function extractSectionId(element) {
  element = element.classList.contains("shopify-section") ? element : element.closest(".shopify-section");
  return element.id.replace("shopify-section-", "");
}

async function extractProduct(id) {
  url = `${Shopify.routes.root}search?type=product&q=id:${id}&section_id=main-search`, response = await fetch(url, { priority: "low" });
  const html = new DOMParser().parseFromString(await response.text(), "text/html");
  return html.querySelector('.collection-wrapper .slide-wrapper');
}

function convertToDecimalWithRegex(input) {
  const cleanedInput = input.replace(/[^\d,.-]/g, '').replace(',', '.');
  // console.log(cleanedInput);
  
  return parseFloat(cleanedInput);
}

async function processEdgesProduct(edges, productCard, plus, button, minPrice, wrapper) {

  let maxPrice = 0;
  // console.log(edges);
  for (let index = 0; index < edges.length; index++) {
    const el = edges[index];

    const id = el.node.productVariant.product.id.split('/').at(-1);
    // console.log(id);
    
    const url = `${Shopify.routes.root}search?type=product&q=id:${id}&section_id=main-search`;

    try {
      const res = await fetch(url, { priority: "low" });
      const data = await res.text();
      const html = new DOMParser().parseFromString(data, "text/html");

      const incomingData = html.querySelector('.collection-wrapper .bottom-wrapper');
      const title = el.node.quantity + ' x ' + incomingData.querySelector('.title').textContent;
      const cloneCard = productCard.cloneNode(true);
      const clonePlus = plus.cloneNode(true);

      cloneCard.querySelector('.save').remove();
      const image = cloneCard.querySelector('.product-image img');
      const imageWrapper = cloneCard.querySelector('.product-image');
      imageWrapper.href = incomingData.querySelector('.title').href;
      image.src = el.node.productVariant.product.featuredImage.url;
      image.removeAttribute('srcset');
      image.alt = title;

      if (incomingData) {
        cloneCard.querySelector('.product-content-wrapper').innerHTML = incomingData.innerHTML;
        let price = incomingData.querySelector('.price').dataset.price;
        maxPrice += price * el.node.quantity;
      }

      cloneCard.querySelector('.specs')?.remove();
      cloneCard.querySelector('.action-wrapper')?.remove();
      cloneCard.querySelector('.title').innerHTML = title;
      if (incomingData.querySelector('.title').textContent == document.querySelector('.title-area h1')?.textContent) {
        if (index == edges.length - 1) {
          wrapper.insertAdjacentElement('afterbegin', cloneCard);
          const plusIcons = wrapper.querySelectorAll('.plus-icon');
          const lastPlus = plusIcons[plusIcons.length - 1];
          cloneCard.insertAdjacentElement('afterend', lastPlus);
        } else {
          wrapper.insertAdjacentElement('afterbegin', cloneCard);
          cloneCard.insertAdjacentElement('afterend', clonePlus);
        }
      } else {
        // alert('this is check what should be inserted');
        wrapper.appendChild(cloneCard);              
      }
      if (index < edges.length - 1) {       
        if (incomingData.querySelector('.title').textContent != document.querySelector('.title-area h1')?.textContent) {
          wrapper.appendChild(clonePlus);
          // alert('plus if not match');
        }
      } else {
        clonePlus.innerHTML = `
          <svg stroke="currentColor" fill="none" stroke-width="0" viewBox="0 0 24 24" height="36" width="36" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 9C4.44772 9 4 9.44771 4 10C4 10.5523 4.44772 11 5 11H19C19.5523 11 20 10.5523 20 10C20 9.44771 19.5523 9 19 9H5Z" fill="currentColor"></path>
            <path d="M5 13C4.44772 13 4 13.4477 4 14C4 14.5523 4.44772 15 5 15H19C19.5523 15 20 14.5523 20 14C20 13.4477 19.5523 13 19 13H5Z" fill="currentColor"></path>
          </svg>
        `;
        wrapper.appendChild(clonePlus);

        const cloneLast = productCard.cloneNode(true);
        cloneLast.querySelector('.product-image').remove();
        cloneLast.querySelector('.s4').remove();
        cloneLast.querySelector('.save span').innerHTML = formatMoney(maxPrice - minPrice , window.themeVariables.settings.moneyFormat);
        cloneLast.classList.add('last');
        cloneLast.querySelector('.compare-price').innerHTML = formatMoney(maxPrice, window.themeVariables.settings.moneyFormat);
        cloneLast.querySelector('.price').innerHTML = formatMoney(minPrice, window.themeVariables.settings.moneyFormat);
        const percentage = ((maxPrice - minPrice) / maxPrice) * 100;
        const percEl = document.createElement('div');
        percEl.classList.add('percentage');
        percEl.innerHTML = `${parseInt(percentage)}%`;
        cloneLast.querySelector('.product-content-wrapper').appendChild(percEl);
        wrapper.appendChild(cloneLast);
        cloneLast.appendChild(button);
      }
    } catch (error) {
      console.error('Error fetching product:', error);
    }
  }
}

async function processEdgesPage(edges, productCard, plus, button, minPrice, wrapper) {
  let searchUrl = `${Shopify.routes.root}search?type=product&q=`;
  let maxPrice = 0;
  const mainArray = [];
  for (let index = 0; index < edges.length; index++) {
    const el = edges[index];
    const id = el.node.productVariant.product.id.split('/').at(-1);
    if (id === wrapper.dataset.mainProduct) {
      mainArray.unshift(el);
    } else {
      mainArray.push(el);
    }
  }
  // console.log(mainArray);
  
  for (let index = 0; index < mainArray.length; index++) {
    const el = mainArray[index];
    const id = el.node.productVariant.product.id.split('/').at(-1);
    index < mainArray.length - 1 ? searchUrl += `id:${id}%20OR%20` : searchUrl += `id:${id}&section_id=main-search`;
  }
  
  const res = await fetch(searchUrl, { priority: "low" });
  const data = await res.text();
  const html = new DOMParser().parseFromString(data, "text/html");
  const products = Array.from(html.querySelectorAll('.slide-wrapper'));
  const bundleProducts = products.reverse();
  if (bundleProducts.length > 0) {
    for (let index = 0; index < mainArray.length; index++) {
      const el = mainArray[index];
      const id = el.node.productVariant.product.id.split('/').at(-1);
      const incomingData = html.querySelector(`[data-product-id="${id}"]`);
      const title = el.node.quantity + ' x ' + incomingData.querySelector('.title').textContent;
      
      const cloneCard = productCard.cloneNode(true);
      const clonePlus = plus.cloneNode(true);
      cloneCard.querySelector('.save').remove();
      const imageWrapper = cloneCard.querySelector('.product-image');
      imageWrapper.href = incomingData.querySelector('.title').href;
      const image = cloneCard.querySelector('.product-image img');
      image.src = incomingData.querySelector('img').src;
      image.removeAttribute('srcset');
      image.alt = title;
      if (incomingData) {
        cloneCard.querySelector('.product-content-wrapper').innerHTML = incomingData.querySelector('.bottom-wrapper').innerHTML;
        cloneCard.querySelector('.images')?.remove();
        let price = incomingData.querySelector('.price').dataset.price;
        maxPrice += price * el.node.quantity;
      }
      cloneCard.querySelector('.specs')?.remove();
      cloneCard.querySelector('.action-wrapper')?.remove();
      cloneCard.querySelector('.title').innerHTML = title;
      cloneCard.querySelector('.title').setAttribute('target', '_blank');
      if (index < bundleProducts.length - 1) {       
          wrapper.appendChild(cloneCard);
          wrapper.appendChild(clonePlus);
      } else {
        wrapper.appendChild(cloneCard);
        clonePlus.innerHTML = `
          <svg stroke="currentColor" fill="none" stroke-width="0" viewBox="0 0 24 24" height="36" width="36" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 9C4.44772 9 4 9.44771 4 10C4 10.5523 4.44772 11 5 11H19C19.5523 11 20 10.5523 20 10C20 9.44771 19.5523 9 19 9H5Z" fill="currentColor"></path>
            <path d="M5 13C4.44772 13 4 13.4477 4 14C4 14.5523 4.44772 15 5 15H19C19.5523 15 20 14.5523 20 14C20 13.4477 19.5523 13 19 13H5Z" fill="currentColor"></path>
          </svg>
        `;
        wrapper.appendChild(clonePlus);
        const cloneLast = productCard.cloneNode(true);
        cloneLast.querySelector('.product-image').remove();
        cloneLast.querySelector('.s4').remove();
        cloneLast.querySelector('.save span').innerHTML = formatMoney(maxPrice - minPrice , window.themeVariables.settings.moneyFormat);
        cloneLast.classList.add('last');
        cloneLast.querySelector('.compare-price').innerHTML = formatMoney(maxPrice, window.themeVariables.settings.moneyFormat);
        cloneLast.querySelector('.price').innerHTML = formatMoney(minPrice, window.themeVariables.settings.moneyFormat);
        const percentage = ((maxPrice - minPrice) / maxPrice) * 100;
        const percEl = document.createElement('div');
        percEl.classList.add('percentage');
        percEl.innerHTML = `${parseInt(percentage)}%`;
        cloneLast.querySelector('.product-content-wrapper').appendChild(percEl);
        wrapper.appendChild(cloneLast);
        cloneLast.appendChild(button);
      }
    }
  }
}

async function processEdgesSidebar(edges, productCard, block, minPrice) {
  let maxPrice = 0;
  const wrapper = block.querySelector('.bundle-items');
  // console.log(edges);
  for (let index = 0; index < edges.length; index++) {
    const el = edges[index];

    const id = el.node.productVariant.product.id.split('/').at(-1);
    // console.log(id);
    
    const url = `${Shopify.routes.root}search?type=product&q=id:${id}&section_id=main-search`;

    try {
      const res = await fetch(url, { priority: "low" });
      const data = await res.text();
      const html = new DOMParser().parseFromString(data, "text/html");

      const incomingData = html.querySelector('.collection-wrapper .bottom-wrapper');
      
      if (incomingData) {
        const title = el.node.quantity + ' x ' + incomingData.querySelector('.title').textContent;
        const priceHtml = incomingData.querySelector('.prices');
        const cloneCard = productCard.cloneNode(true);
        cloneCard.querySelector('.product-name').innerHTML = title;
        cloneCard.querySelector('.product-price').innerHTML = priceHtml.innerHTML;
        let price = incomingData.querySelector('.price').dataset.price;
        maxPrice += price * el.node.quantity;
        wrapper.appendChild(cloneCard);

      }
    } catch (error) {
      console.error('Error fetching product:', error);
    }
  }
  const percentage = (((maxPrice - minPrice) / maxPrice) * 100).toFixed(0);
  const economies = block.querySelectorAll('.economy');
  const beforePrices = block.querySelectorAll('.price-before-dynamic');
  beforePrices.forEach(e => e.innerHTML = formatMoney(maxPrice, window.themeVariables.settings.moneyFormat));
  economies.forEach(e => e.innerHTML = e.textContent.replace('%s', percentage+'%'));
  
}

function sidebarBundle() {
  const block = document.querySelector('.product-bundles-sidebar');
  if (block) {
    const storefrontAccessToken = window.themeVariables.settings.storefrontKey;
    const query = `
      {
        productByHandle(handle: "${block.dataset.handle}") {
          variants(first: 10) {
            edges {
              node {
                id
                components(first: 10) {
                  edges {
                    node {
                      productVariant {
                        product {
                          id
                        }
                      }
                      quantity
                    }
                  }
                }
              }
            }
          }
        }
      }
    `;

    fetch(`${Shopify.routes.root}api/2024-07/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
      },
      body: JSON.stringify({ query }),
    })
    .then((res) => res.json())
    .then((data) => {
      console.log(data.data.productByHandle.variants.edges[0].node.components.edges);
      const edges = data.data.productByHandle.variants.edges[0].node.components.edges;
      const productCard = block.querySelector('.bundle-items .item').cloneNode(true);
      
      const minPrice = block.dataset.priceBefore;
      block.querySelector('.bundle-items .item').remove();
      processEdgesSidebar(edges, productCard, block, minPrice);
    })
  }
}

function bundles() {
  const block = document.querySelector('.product-bundles .bundles');
  if (block) {
    const storefrontAccessToken = window.themeVariables.settings.storefrontKey;
    // console.log(storefrontAccessToken);
    
    
    const bundleWrappers = document.querySelectorAll('.product-bundles .bundles');
    bundleWrappers.forEach(wrapper => {
      // console.log(wrapper.dataset.handle);
      const query = `
        {
          productByHandle(handle: "${wrapper.dataset.handle}") {
            variants(first: 10) {
              edges {
                node {
                  id
                  components(first: 10) {
                    edges {
                      node {
                        productVariant {
                          product {
                            id
                            title
                            handle
                            featuredImage {
                              url
                            }
                          }
                          price {
                            amount
                          }
                        }
                        quantity
                      }
                    }
                  }
                }
              }
            }
          }
        }
      `;

      


      fetch(`${Shopify.routes.root}api/2024-07/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
        },
        body: JSON.stringify({ query }),
      })
      .then((res) => res.json())
      .then((data) => {
        // console.log(data);
        
        const edges = data.data.productByHandle.variants.edges[0].node.components.edges;
        const productCard = wrapper.querySelector('.product-card').cloneNode(true);
        wrapper.querySelector('.product-card').remove();
        const plus = wrapper.querySelector('.plus-icon').cloneNode(true);
        wrapper.querySelector('.plus-icon').remove();
        const button = wrapper.querySelector('button').cloneNode(true);
        wrapper.querySelector('button').remove();
        let minPrice = parseInt(wrapper.dataset.price);
        processEdgesProduct(edges, productCard, plus, button, minPrice, wrapper);
      });
    })
  }
}

function pageBundles() {
  const block = document.querySelector('.page-bundles .bundles');
  if (block) {
    const storefrontAccessToken = window.themeVariables.settings.storefrontKey;
    const bundleWrappers = document.querySelectorAll('.page-bundles .bundles');
    bundleWrappers.forEach(wrapper => {
      
      const query = `
        {
          productByHandle(handle: "${wrapper.dataset.handle}") {
            variants(first: 10) {
              edges {
                node {
                  id
                  components(first: 10) {
                    edges {
                      node {
                        productVariant {
                          product {
                            id
                            title
                            handle
                            featuredImage {
                              url
                            }
                          }
                          price {
                            amount
                          }
                        }
                        quantity
                      }
                    }
                  }
                }
              }
            }
          }
        }
      `;

      fetch(`${Shopify.routes.root}api/2024-07/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
        },
        body: JSON.stringify({ query }),
      })
      .then((res) => res.json())
      .then((data) => {
        
        const edges = data.data.productByHandle.variants.edges[0].node.components.edges;
        const productCard = wrapper.querySelector('.product-card').cloneNode(true);
        wrapper.querySelector('.product-card').remove();
        const plus = wrapper.querySelector('.plus-icon').cloneNode(true);
        wrapper.querySelector('.plus-icon').remove();
        const button = wrapper.querySelector('button').cloneNode(true);
        wrapper.querySelector('button').remove();
        let minPrice = parseInt(wrapper.dataset.price);
        processEdgesPage(edges, productCard, plus, button, minPrice, wrapper);
      });
    })
  }
}

function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
    default:
      value = formatWithDelimiters(cents, 2);
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}

var currencyFormat = window.themeVariables.settings.moneyFormat;

function sectionSliderText() {
  const blocks = document.querySelectorAll('.section-slider-text');
  if (blocks.length > 0) {
    blocks.forEach(block => {
      const slider = block.querySelector('swiper-container');
      const swiperParams = {
        slidesPerView: 1,
        navigation: {
          nextEl: block.querySelector('.next'),
          prevEl: block.querySelector('.prev'),
        },
        pagination: {
          el: block.querySelector('progress-bar'),
          type: 'progressbar',
        },
        breakpoints: {
          1280: {
            slidesPerView: 1,
            spaceBetween: 16,
          },
          768: {
            slidesPerView: 1,
            spaceBetween: 16,
          },
          0: {
            slidesPerView: 1.2,
            spaceBetween: 16,
            navigation: false
          }
        }
      };
      Object.assign(slider, swiperParams);
      slider.initialize();
    })
  }
}

function sectionVideos() {
  const block = document.querySelector('.section-videos');
  if (block) {
    const videos = block.querySelectorAll('.overlay');
    const drawer = block.querySelector('.global-video-drawer');
    const close = drawer.querySelector('.close');
    let player;
    close.addEventListener('click', function() {
      hide(drawer);
      triggerOverlay();
      let movie;
      if (drawer.querySelector('video')) {
        movie = drawer.querySelector('.video-wrapper video');
        movie.pause();
      } else {
        player.stopVideo();
      }
    })
    // console.log(videos);
    if (videos.length > 0) {
      videos.forEach(video => {
        video.addEventListener('click', function() {
          
          
          const videoBlock = video.closest('.video').querySelector('.video-block');
          const movie = videoBlock.dataset.type == 'selfhosted' ? videoBlock.querySelector('video') : videoBlock.querySelector('.youtube-wrapper');
          const clone = document.importNode(movie, true);
          if (movie) {
            drawer.querySelector('.video-wrapper').innerHTML = '';
            drawer.querySelector('.video-wrapper').insertAdjacentElement('beforeend', clone);
            if (videoBlock.dataset.type == 'selfhosted') {
              clone.play();
            } else {
              
              player = new YT.Player(clone, {
                videoId: clone.dataset.videoId,
                events: {
                  'onReady': onPlayerReady
                }
              });
              function onPlayerReady(event) {
                event.target.playVideo();
              }
            }
            show(drawer);
            triggerOverlay();
          }
        })
      })
    }
  }
}

function recentlyViewed() {
  var __accessCheck = (obj, member, msg) => {
    if (!member.has(obj))
      throw TypeError("Cannot " + msg);
  };
  var __privateGet = (obj, member, getter) => {
    __accessCheck(obj, member, "read from private field");
    return getter ? getter.call(obj) : member.get(obj);
  };
  var __privateAdd = (obj, member, value) => {
    if (member.has(obj))
      throw TypeError("Cannot add the same private member more than once");
    member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
  };
  var __privateSet = (obj, member, value, setter) => {
    __accessCheck(obj, member, "write to private field");
    setter ? setter.call(obj, value) : member.set(obj, value);
    return value;
  };
  var __privateMethod = (obj, member, method) => {
    __accessCheck(obj, member, "access private method");
    return method;
  };
  function extractSectionId(element) {
    element = element.classList.contains("shopify-section") ? element : element.closest(".shopify-section");
    return element.id.replace("shopify-section-", "");
  }
  var _isLoaded, _searchQueryString, searchQueryString_get, _loadProducts, loadProducts_fn;
  var RecentlyViewedProducts = class extends HTMLElement {
    constructor() {
      super(...arguments);
      __privateAdd(this, _searchQueryString);
      __privateAdd(this, _loadProducts);
      __privateAdd(this, _isLoaded, false);
    }
    connectedCallback() {
      if ("requestIdleCallback" in window) {
        requestIdleCallback(__privateMethod(this, _loadProducts, loadProducts_fn).bind(this), { timeout: 1500 });
        // console.log('first');
      } else {
        __privateMethod(this, _loadProducts, loadProducts_fn).call(this);
        // console.log('second');
      }
    }
  };
  _isLoaded = new WeakMap();
  _searchQueryString = new WeakSet();
  searchQueryString_get = function() {
    const items = new Set(JSON.parse(localStorage.getItem("theme:recently-viewed-products") || "[]"));
    if (this.hasAttribute("exclude-id")) {
      items.delete(parseInt(this.getAttribute("exclude-id")));
    }
    return Array.from(items.values(), (item) => `id:${item}`).slice(0, parseInt(this.getAttribute("products-count"))).join(" OR ");
  };
  _loadProducts = new WeakSet();
  loadProducts_fn = async function() {
    if (__privateGet(this, _isLoaded)) {
      return;
    }
    __privateSet(this, _isLoaded, true);
    const section = this.closest(".shopify-section"), url = `${Shopify.routes.root}search?type=product&q=${__privateGet(this, _searchQueryString, searchQueryString_get)}&section_id=${extractSectionId(section)}`, response = await fetch(url, { priority: "low" });
    
    const tempDiv = new DOMParser().parseFromString(await response.text(), "text/html"), recentlyViewedProductsElement = tempDiv.querySelector("recently-viewed-products");
    if (recentlyViewedProductsElement.childElementCount > 0) {
      this.replaceChildren(...document.importNode(recentlyViewedProductsElement, true).childNodes);
      const slider = this.querySelector('.recent-list-slider');
      if (slider) {
        const swiperParams = {
          slidesPerView: 3,
          navigation: {
            nextEl: section.querySelector('.next'),
            prevEl: section.querySelector('.prev'),
          },
          pagination: {
            el: section.querySelector('progress-bar'),
            type: 'progressbar',
          },
          breakpoints: {
            1280: {
              slidesPerView: 4,
              slidesPerGroup: 1,
            },
            768: {
              slidesPerView: 2,
              slidesPerGroup: 1,
            },
            0: {
              slidesPerView: 1.2,
              slidesPerGroup: 1,
            }
          }
        };
        Object.assign(slider, swiperParams);
        slider.initialize();
      }
    } else {
      section.remove();
    }
  };
  if (!window.customElements.get("recently-viewed-products")) {
    window.customElements.define("recently-viewed-products", RecentlyViewedProducts);
  }
}

// Utility

Array.prototype.shuffle = function() {
  for (let i = this.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [this[i], this[j]] = [this[j], this[i]];
  }
  return this;
};

function fadeOut(element, duration) {
  var start = performance.now();

  function animate(currentTime) {
    var elapsed = currentTime - start;
    var progress = elapsed / duration;

    element.style.opacity = Math.max(1 - progress, 0);

    if (progress < 1) {
      requestAnimationFrame(animate);
    } else {
      element.style.display = 'none';
    }
  }

  requestAnimationFrame(animate);
}

function fadeIn(element, duration, type) {
  element.style.display = type;
  element.style.opacity = 0;
  var start = performance.now();

  function animate(currentTime) {
    var elapsed = currentTime - start;
    var progress = elapsed / duration;

    element.style.opacity = Math.min(progress, 1);

    if (progress < 1) {
      requestAnimationFrame(animate);
    }
  }

  requestAnimationFrame(animate);
}

function triggerOverlay() {
  // console.log('triggers');
  
  const overlay = document.querySelector('#mainOverlay');
  // console.log(overlay);
  
  if (overlay) {
    const html = document.querySelector('html');
    const body = document.querySelector('body');
    if (document.querySelectorAll('.popup.active').length > 0) {
      overlay.classList.add('active');
      body.style.overflow = 'visible';
      html.style.overflow = 'hidden';

      smoothScroll('stop');
    } else {
      overlay.classList.remove('active')
      html.style.removeProperty('overflow');
      body.style.removeProperty('overflow');
      smoothScroll('play');
    }
  }
}

function hide(el) {
  el.classList.remove('active');
}

function show(el) {
  el.classList.add('active');
}

function toggle(el) {
  el.classList.toggle('active');
}

function easeOut(t) {
  return t * (2 - t);
}

function overlayClose() {
  const overlay = document.querySelector('#mainOverlay');
  if (overlay) {
    overlay.addEventListener('click', function() {
      const activePopups = document.querySelectorAll('.popup.active');
      const menuWrapper = document.querySelector('.main-menu-drawer .menu-wrapper');
      const html = document.querySelector('html');
      const body = document.querySelector('body');
      if (menuWrapper) {
        const menus = menuWrapper.querySelectorAll(`.first-level-wrapper`);
        menus.forEach(e => {
          hide(e);
        })
        const secondLevel = menuWrapper.querySelector('.second-level');
        fadeOut(secondLevel, 300);
      }
      activePopups.forEach(e => e.classList.remove('active'));
      hide(overlay);
      html.style.removeProperty('overflow');
      body.style.removeProperty('overflow');
      smoothScroll('play');
    })
  }
}



function debounce(func, delay) {
  let timeoutId;
  return function() {
      const context = this;
      const args = arguments;
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
          func.apply(context, args);
      }, delay);
  };
}

function titleGsap() {
  const titles = document.querySelectorAll('.section-wrapper .title-wrapper');
  if (titles.length > 0) {
    titles.forEach(title => {
      if (title.querySelector('.title')) {
        const heading = title.querySelector('.title');
        const trigger = {
          trigger: title,
            start: '80px 100%'
        };
        gsap.to(heading, {
          scrollTrigger: trigger,
          y: 0,
          duration: 1.5,
          ease: 'power4.out'
        })
      }
    })
  }
}

const lenis = new Lenis();
function smoothScroll(state) {

  if (state === 'play') {
    lenis.start();

    lenis.on('scroll', ScrollTrigger.update)

    gsap.ticker.add((time)=>{
      lenis.raf(time * 1000)
    })

    gsap.ticker.lagSmoothing(0);
  } else if (state === 'stop') {
    lenis.stop();
  }
  
}

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const targetId = this.getAttribute('href').substring(1);
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
          lenis.scrollTo(targetElement);
      } else {
          console.warn(`Element with id "${targetId}" not found`);
      }
  });
});

// Header

function header() {
  const header = document.querySelector('header');
  const menu = header.querySelector('.main-menu');
  
  if (menu && header) {
    const menuDrawer = document.querySelector('.main-menu-drawer');
    menuDrawer.appendChild(header.querySelector('.menu-wrapper'))
    const menuWrapper = menuDrawer.querySelector('.menu-wrapper');
    const links = menu.querySelectorAll('div.menu-link');
    const core = menuWrapper.querySelector('.first-level-wrapper[data-slug="core"]');
    const coreLinks = core.querySelectorAll('div.link');
    const innerLinks = menuWrapper.querySelectorAll('li.link[data-inner-slug]');
    links.forEach(link => {
      link.addEventListener('click', function(){
        setTimeout(function() {
          menuWrapper.classList.toggle('active');
          triggerOverlay();
        }, 200);
        this.dataset.slug ? menuWrapper.querySelector(`.first-level-wrapper .link[data-slug="${this.dataset.slug}"]`).click() : null;
        
      })
    });
    const close = menuWrapper.querySelectorAll('.close');
    close.forEach(e => {
      e.addEventListener('click', function() {
        const secondLevel = menuWrapper.querySelector('.second-level');
        const menus = menuWrapper.querySelectorAll(`.first-level-wrapper`);
        menus.forEach(e => {
          e.classList.remove('active');
        })
        menuWrapper.classList.remove('active');
        fadeOut(secondLevel, 300);
        triggerOverlay();
      })
    });

    const back = menuWrapper.querySelectorAll('.back');
    back.forEach(e => {
      e.addEventListener('click', function(){
        const menuTarget = this.closest('.first-level-wrapper');
        const secondLevel = menuWrapper.querySelector('.second-level');
        menuTarget ? menuTarget.classList.remove('active') : null;
        menuTarget ? core.classList.remove('active') : null;
        fadeOut(secondLevel, 300);
      })
    })

    const deepBack = header.querySelectorAll('.deep-back');
    deepBack.forEach(e => {
      e.addEventListener('click', function() {
        fadeOut(e.closest('.second-level'), 300);
      })
    })

    coreLinks.forEach(link => {
      link.addEventListener('click', function() {
        const menuTarget = menuWrapper.querySelector(`.first-level-wrapper[data-slug="${this.dataset.slug}"]`);
        menuTarget.classList.add('active');
        core.classList.add('active');
      })
    })
    innerLinks.forEach(link => {
      link.addEventListener('click', function() {
        const secondLevel = menuWrapper.querySelector('.second-level');
        const menuTarget = secondLevel.querySelector(`[data-slug="${this.dataset.innerSlug}"]`);
        const allTargets = secondLevel.querySelectorAll(`[data-slug]`);
        var slug = this.dataset.innerSlug;
        secondLevel.style.display === 'block' ? null : fadeIn(secondLevel, 300, 'block');        
        allTargets.forEach(e => {
          if (e.dataset.slug !== slug) {
            fadeOut(e, 300);
          } else {
            fadeIn(menuTarget, 300, 'block');
          }
        })
      })
    })
    const insideSection = header.querySelector('.header-wrapper');
    let prevScroll = window.scrollY;
    prevScroll > insideSection.clientHeight ? () => {
      show(insideSection);
      setTimeout(() => {
        insideSection.style.transition = 'var(--tr)';
    }, 300)} : null;
    window.addEventListener('scroll', function(evt) {
      let currentScroll = window.scrollY;
      // console.log(insideSection.clientHeight);
      if (this.window.scrollY > insideSection.clientHeight) {
        header.style.minHeight = insideSection.clientHeight + 'px';
        if (currentScroll > prevScroll) {
          insideSection.style.transform = 'translateY(-100%)';
          const sticked = document.querySelector('.product-nav.sticked');
          if (sticked) {
            // console.log(sticked);
            sticked.style.transform = 'translateY(0%)';
          }
        } else {
          insideSection.style.transform = 'translateY(0)';
          const sticked = document.querySelector('.product-nav.sticked');
          if (sticked) {
            sticked.style.transform = `translateY(${header.clientHeight}px)`;
          }
        }
        this.setTimeout(() => {
          show(insideSection);
          insideSection.style.transition = 'var(--tr)';
        }, 100)
        
        prevScroll = currentScroll;
      }
      if (this.window.scrollY < 1) {
        hide(insideSection);
        this.setTimeout(() => {
          insideSection.style.transition = 'none';
        }, 100)
      }
    })
  }
}

// Main accordion

function mainAccordion() {

  const blocks = document.querySelectorAll('.main-accordion');



  function mouseEnterHandler(event) {
      const activeItem = event.currentTarget.closest('.main-accordion').querySelector('.active');
      // if (window.innerWidth > 1024) {
        hide(activeItem);
        hide(activeItem.querySelector('.top-part'));
        hide(activeItem.querySelector('.bottom-part'));
      // }
      show(event.currentTarget);
      show(event.currentTarget.querySelector('.top-part'));
      show(event.currentTarget.querySelector('.bottom-part'));
      
  }

  function mouseClickHandler(event) {
    const url = event.target.closest('.accordion-item').dataset.url;
    // console.log(event.target.closest('.accordion-item'));
    
    window.location.href = `${url}`
    
  }

  // function scrollHandler(block) {
  //   return function(event) {
  //     if (window.innerWidth < 1024) {
  //       const items = block.querySelectorAll('.accordion-item');
  //       items.forEach(item => {
  //           const rect = item.getBoundingClientRect();
  //           if (rect.top < 200) {
  //               show(item);
  //               show(item.querySelector('.top-part'));
  //               show(item.querySelector('.bottom-part'));
  //           }
  //       });
  //     }
  //   };
  // }
  function handleViewportChange() {
      blocks.forEach(block => {
          const items = block.querySelectorAll('.accordion-item');
          // items.forEach((item, index) => {
          //   if (index === 0) {
          //     show(item);
          //     show(item.querySelector('.top-part'));
          //     show(item.querySelector('.bottom-part'));
          //   } else {
          //     hide(item);
          //     hide(item.querySelector('.top-part'));
          //     hide(item.querySelector('.bottom-part'));
          //   }
          // })
          items.forEach(item => {
              // if (window.innerWidth < 1024) {
                  item.addEventListener('mouseenter', mouseEnterHandler);
                  if (window.innerWidth > 1024) {
                    item.addEventListener('click', mouseClickHandler);
                    
                  }
              // } else {
                  // item.addEventListener('mouseenter', mouseEnterHandler);
              // }
          });
          // window.addEventListener('scroll', scrollHandler(block));
      });
  }

  handleViewportChange();

  window.addEventListener('resize', handleViewportChange);
}

// Hero

function heroSlider() {
  const sliders = document.querySelectorAll('.hero-slider');
  if (sliders.length > 0) {
    sliders.forEach(slider => {
      const swiperParams = {
        slidesPerView: 1,
        navigation: {
          nextEl: slider.nextElementSibling.querySelector('.next'),
          prevEl: slider.nextElementSibling.querySelector('.prev'),
        },
        pagination: {
          el: slider.nextElementSibling.querySelector('progress-bar'),
          type: 'progressbar',
        },
      };
      Object.assign(slider, swiperParams);
      slider.initialize();
    })
  }
}

// marquee section 

function marquee() {
  const sliders = document.querySelectorAll('.marquee');
  if (sliders.length > 0) {
    sliders.forEach(slider => {
      const wrapper = slider.querySelector('.marquee-wrapper');
      var reeller = new Reeller.Reeller({
        container: slider,
        wrapper: wrapper,
        itemSelector: '.slide',
        speed: 100,
        reversed: true,
      });
      wrapper.addEventListener('mouseenter', () => {
        reeller.pause();
      })
      wrapper.addEventListener('mouseleave', () => {
        reeller.resume();
      })
    })
  }
}

// medals section 

function medals() {
  const sections = document.querySelectorAll('.section-medals');
  if (sections.length > 0) {
    sections.forEach(section => {
      // slider
      const slider = section.querySelector('.medals-slider');
      // console.log(slider);
      const swiperParams = {
        slidesPerView: 5,
        navigation: {
          nextEl: section.querySelector('.next'),
          prevEl: section.querySelector('.prev'),
        },
        pagination: {
          el: section.querySelector('progress-bar'),
          type: 'progressbar',
        },
        breakpoints: {
          1024: {
            slidesPerView: 5,
            slidesPerGroup: 1,
            spaceBetween: 16,
          },
          768: {
            slidesPerView: 4,
            slidesPerGroup: 1,
            spaceBetween: 16,
          },
          0: {
            slidesPerView: 2,
            slidesPerGroup: 1,
            spaceBetween: 12,
          }
        }
      };
      Object.assign(slider, swiperParams);
      slider.initialize();
      // popup
      const popups = section.querySelectorAll('.popup-content')
      if (popups.length > 0) {
        const popup = section.querySelector('.medals-popup');
        popups.forEach(e =>{
          const trigger = e.closest('.slide-wrapper');
          trigger.addEventListener('click', function(){
            popup.querySelector('.content').innerHTML = e.innerHTML;
            show(popup);
            triggerOverlay();
          })
        })
        const close = popup.querySelector('.close svg');
        close.addEventListener('click', function() {
          hide(popup);
          triggerOverlay();
        })
      }
    })
  }
}

// awards list

function awardsList() {
  const section = document.querySelector('.section-awards');
  if (section) {
    const popups = section.querySelectorAll('.popup-content')
    if (popups.length > 0) {
      const popup = section.querySelector('.awards-popup');
      popups.forEach(e =>{
        const trigger = e.closest('.slide-wrapper');
        trigger.addEventListener('click', function(){
          popup.querySelector('.content').innerHTML = e.innerHTML;
          show(popup);
          triggerOverlay();
        })
      })
      const close = popup.querySelector('.close svg');
      close.addEventListener('click', function() {
        hide(popup);
        triggerOverlay();
      })
    }
  }
}

// featured blog 

function featuredBlog() {
  const sections = document.querySelectorAll('.featured-blog');
  if (sections.length > 0) {
    sections.forEach(section => {
      const slider = section.querySelector('.blog-slider');
      // console.log(slider);
      const swiperParams = {
        slidesPerView: 5,
        navigation: {
          nextEl: section.querySelector('.next'),
          prevEl: section.querySelector('.prev'),
        },
        pagination: {
          el: section.querySelector('progress-bar'),
          type: 'progressbar',
        },
        breakpoints: {
          1280: {
            slidesPerView: 4,
            slidesPerGroup: 1,
            spaceBetween: 16,
          },
          1024: {
            slidesPerView: 4,
            slidesPerGroup: 1,
            spaceBetween: 16,
          },
          768: {
            slidesPerView: 3,
            slidesPerGroup: 1,
            spaceBetween: 16,
          },
          0: {
            slidesPerView: 1.3,
            slidesPerGroup: 1,
            spaceBetween: 12,
          }
        }
      };
      Object.assign(slider, swiperParams);
      slider.initialize();
    })
  }
}

// product sliders 

function productSliders() {
  const section = document.querySelector('.product-media');
  if (section && section.querySelector('.thumbs')) {
    const slider = section.querySelector('.product-slider');
    const thumbs = section.querySelectorAll('.product-media .thumbs .thumb');
    const viewMore = section.querySelector('.view-more');
    if (slider) {
      const swiperParams = {
        slidesPerView: 1,
        spaceBetween: 1,
        navigation: {
          nextEl: section.querySelector('.next'),
          prevEl: section.querySelector('.prev'),
        },
        pagination: {
          el: section.querySelector('progress-bar')
        }
      };
      Object.assign(slider, swiperParams);
      slider.initialize();

      slider.swiper.slides.forEach((e, i) => {
        e.addEventListener('click', function(evt) {
          document.querySelector('.product-media-popup .product-slider').swiper.slideTo(i);
          show(drawer);
          triggerOverlay();
        })
      })
    }
    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => {
        slider.swiper.slideTo(index);
      })
    })
    slider.swiper.on('slideChange', function(evt) {
      thumbs.forEach(e => {e.classList.remove('active')});
      this.activeIndex < 6 ? thumbs[this.activeIndex].classList.add('active') : null;
    })
    if (viewMore) {
      viewMore.addEventListener('click', function() {
        show(drawer);
        triggerOverlay();
      })
    }
  }
  const drawer = document.querySelector('.product-media-popup');
  if (drawer) {
    const thumbsWrapper = drawer.querySelector('.thumbs');
    const thumbs = thumbsWrapper.querySelectorAll('.thumb');
    const slider = drawer.querySelector('.product-slider');
    const close = drawer.querySelector('.close');
    close.addEventListener('click', function() {
      hide(drawer);
      triggerOverlay();
    })
    if (slider) {
      const swiperParams = {
        slidesPerView: 1,
        // autoHeight: 1,
        spaceBetween: 1,
        navigation: {
          nextEl: drawer.querySelector('.next'),
          prevEl: drawer.querySelector('.prev'),
        }
      };
      Object.assign(slider, swiperParams);
      slider.initialize();
    }
    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => {
        slider.swiper.slideTo(index);
      })
    })
    slider.swiper.on('slideChange', function(evt) {
      thumbs.forEach(e => {e.classList.remove('active')});
      const activeThumb = thumbs[this.activeIndex];
      activeThumb.classList.add('active');
      
      const thumbPosition = activeThumb.getBoundingClientRect();
      const wrapperPosition = thumbsWrapper.getBoundingClientRect();
      // if (thumbPosition.bottom > wrapperPosition.bottom || thumbPosition.top < wrapperPosition.top) {
        activeThumb.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
      // }
      // if (window.innerWidth < 768) {
      //   activeThumb.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
      // }
    })
  }
  const related = document.querySelector('#related');
  if (related) {
    fetch(window.Shopify.routes.root + `recommendations/products?product_id=${related.dataset.productId}&limit=10&section_id=product-recommendations&intent=related`)
      .then(response => response.text())
      .then((text) => {
          const parsedHTML = new DOMParser().parseFromString(text, 'text/html');
          related.querySelector('swiper-container').innerHTML = parsedHTML.querySelector('.shopify-section').innerHTML;
          relatedSlider();
    });
    function relatedSlider() {
      const slider = related.querySelector('swiper-container');
      const swiperParams = {
        slidesPerView: 5,
        navigation: {
          nextEl: related.querySelector('.next'),
          prevEl: related.querySelector('.prev'),
        },
        pagination: {
          el: related.querySelector('progress-bar'),
          type: 'progressbar',
        },
        breakpoints: {
          1024: {
            slidesPerView: 4,
            slidesPerGroup: 1,
            spaceBetween: 0,
          },
          768: {
            slidesPerView: 2,
            slidesPerGroup: 1,
            spaceBetween: 0,
          },
          0: {
            slidesPerView: 1.2,
            slidesPerGroup: 1,
            spaceBetween: 0,
          }
        }
      };
      Object.assign(slider, swiperParams);
      slider.initialize();
    }
  }
  const similar = document.querySelector('#similar');
  if (similar) {
    fetch(window.Shopify.routes.root + `recommendations/products?product_id=${similar.dataset.productId}&limit=10&section_id=product-recommendations&intent=complementary`)
      .then(response => response.text())
      .then((text) => {
          const parsedHTML = new DOMParser().parseFromString(text, 'text/html');
          similar.querySelector('swiper-container').innerHTML = parsedHTML.querySelector('.shopify-section').innerHTML;
          similarSlider();
    });
    function similarSlider() {
      const slider = similar.querySelector('.product-list-slider');
      const swiperParams = {
        slidesPerView: 3,
        navigation: {
          nextEl: similar.querySelector('.next'),
          prevEl: similar.querySelector('.prev'),
        },
        pagination: {
          el: similar.querySelector('progress-bar'),
          type: 'progressbar',
        },
        breakpoints: {
          1280: {
            slidesPerView: 4,
            slidesPerGroup: 1,
          },
          768: {
            slidesPerView: 3,
            slidesPerGroup: 1,
          },
          0: {
            slidesPerView: 1.2,
            slidesPerGroup: 1,
          }
        }
      };
      Object.assign(slider, swiperParams);
      slider.initialize();
    }
    

    const insideWrappers = similar.querySelectorAll('.images');
    insideWrappers.forEach(insideWrapper => {
      const insideSlider = insideWrapper.querySelector('swiper-container');
      const params = {
        slidesPerView: 1,
        navigation: {
          nextEl: insideWrapper.querySelector('.next'),
          prevEl: insideWrapper.querySelector('.prev'),
        }
      };
      Object.assign(insideSlider, params);
      insideSlider.initialize();
    })
  }
}

// product nav 

function productNav() {
  const links = document.querySelectorAll('.product-nav li a');
  const nav = document.querySelector('.product-nav');
  if (links.length > 0) {
    const bar = document.querySelector('.product-nav .bar');
    const mobileScroller = bar.closest('.section-wrapper');
    // if (window.innerWidth > 1024) {
    //   mobileScroller.removeAttribute('data-lenis-prevent');
    // }
    let barWidth = links[0].parentElement.offsetWidth;
    let barLeft = links[0].parentElement.offsetLeft;
    bar.style.width = `${barWidth}px`;
    bar.style.left = `${barLeft}px`;
    links.forEach((link, index) => {
      link.addEventListener('click', function(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        setActiveLink(index);
        const target = document.querySelector(`.nav-sections [id="${link.dataset.id}"]`);
        // if (window.innerWidth > 1024) {
          lenis.scrollTo(target, {
            offset: -(nav.clientHeight + document.querySelector('header').clientHeight)
          })
        // }
      })
    })

    const sections = document.querySelectorAll('.nav-sections > *');
      sections.forEach((section, index) => {
        ScrollTrigger.create({
          trigger: section,
          start: "top center",
          end: "bottom center",
          onEnter: () => {
            setActiveLink(index);
            if (index > 0) {
              mobileScroller.scrollBy({
                left: barLeft,
                behavior: 'smooth'
              })
            }
          },
          onLeaveBack: () => {
            setActiveLink(index - 1);
            if (index < 4) {
              mobileScroller.scrollTo({
                left: -barLeft,
                behavior: 'smooth'
              })
            }
          },
      });
    })

    function setActiveLink(index) {
      links.forEach(link => link.classList.remove('active'));
      // console.log(links[index]);
      if (links[index]) {
        links[index].classList.add('active');
        barWidth = links[index].parentElement.offsetWidth;
        barLeft = links[index].parentElement.offsetLeft;
        bar.style.width = `${barWidth}px`;
        bar.style.left = `${barLeft}px`;
        
        // links[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
    }
    
    if (nav) {
      nav.closest('.product-nav-wrapper').style.height = `${nav.clientHeight}px`;
      window.addEventListener('scroll', function(evt) {
        const rects = nav.closest('.product-info-part').getBoundingClientRect();
        // console.log(rects);
        if (rects.top < 1) {
          // console.log('less than');
          nav.classList.add('sticked');
        } else {
          nav.classList.remove('sticked');
          nav.style.transform = 'translateY(0)';
        }
      })
    }
    

  }
}

function productFeatures() {

  const featuresWrapper = document.querySelector('.product-features .features-wrapper');
  
  if (featuresWrapper) {
    const selectors = featuresWrapper.querySelectorAll('.feature-selectors .selector');
    const stickyWrapper = featuresWrapper.querySelector('.feature-contents');
    const initActiveFeature = featuresWrapper.querySelector('.feature-contents .active');
    stickyWrapper.style.height = initActiveFeature.clientHeight + 'px';
    // console.log(stickyWrapper.clientHeight);
    

    selectors.forEach(selector => {
      selector.addEventListener('click', () => {
        if (!selector.classList.contains('active')) {
          const activeButton = featuresWrapper.querySelector('.feature-selectors .active');
          const activeFeature = featuresWrapper.querySelector('.feature-contents .active');
          const target = featuresWrapper.querySelector(`[data-target="featureContent-${selector.dataset.index}"]`);
          hide(activeButton);
          hide(activeFeature);
          stickyWrapper.style.height = target.clientHeight + 'px';
          show(selector);
          show(target);
          
        }
      })
    })
  }

  // const features = document.querySelectorAll('.product-features details');
  // if (features.length > 0) {
    
  //   features.forEach(feature => {
  //     const summaries = feature.querySelectorAll('.summary-content');
  //     if (summaries.length > 0) {
  //       let height = 0;
  //       summaries.forEach(e => {
  //         if (e.scrollHeight > height) {
  //           height = e.scrollHeight;
  //         }
  //       })
  //       feature.closest('.features-wrapper').style.minHeight = `${height + 10}px`;
  //     }
      

  //     if (window.innerWidth > 767) {
  //       feature.open = false;
  //       feature.addEventListener('click', function() {
  //         features.forEach(f => {
  //             f.open = false;
  //         })
  //       })
  //     }      
  //   })
  //   features[0].open = true;
  // }
}

function productInstructions() {
  const block = document.querySelector('.product-instructions');
  if (block) {
    const slider = block.querySelector('swiper-container');
    const swiperParams = {
      slidesPerView: 3,
      navigation: {
        nextEl: block.querySelector('.next'),
        prevEl: block.querySelector('.prev'),
      },
      pagination: {
        el: block.querySelector('progress-bar'),
        type: 'progressbar',
      },
      breakpoints: {
        1280: {
          slidesPerView: 3,
          slidesPerGroup: 1,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 2,
          slidesPerGroup: 1,
          spaceBetween: 16,
        },
        0: {
          slidesPerView: 1.2,
          slidesPerGroup: 1,
          spaceBetween: 16,
        }
      }
    };
    Object.assign(slider, swiperParams);
    slider.initialize();
  }
}

function productVideos() {
  
  const block = document.querySelector('.product-videos');
  if (block) {
    const slider = block.querySelector('swiper-container');
    const swiperParams = {
      slidesPerView: 3,
      navigation: {
        nextEl: block.querySelector('.next'),
        prevEl: block.querySelector('.prev'),
      },
      pagination: {
        el: block.querySelector('progress-bar'),
        type: 'progressbar',
      },
      breakpoints: {
        1280: {
          slidesPerView: 3,
          slidesPerGroup: 1,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 2,
          slidesPerGroup: 1,
          spaceBetween: 16,
        },
        0: {
          slidesPerView: 1.2,
          slidesPerGroup: 1,
          spaceBetween: 16,
        }
      }
    };
    Object.assign(slider, swiperParams);
    slider.initialize();

    const videos = block.querySelectorAll('.overlay');
    const drawer = block.querySelector('.global-video-drawer');
    const close = drawer.querySelector('.close');
    let player;
    close.addEventListener('click', function() {
      hide(drawer);
      triggerOverlay();
      let movie;
      if (drawer.querySelector('video')) {
        movie = drawer.querySelector('.video-wrapper video');
        movie.pause();
      } else {
        player.stopVideo();
      }
    })
    
    if (videos.length > 0) {
      videos.forEach(video => {
        video.addEventListener('click', function() {
          const videoBlock = video.closest('.video-slide').querySelector('.video-block');
          const movie = videoBlock.dataset.type == 'selfhosted' ? videoBlock.querySelector('video') : videoBlock.querySelector('.youtube-wrapper');
          const clone = document.importNode(movie, true);
          if (movie) {
            drawer.querySelector('.video-wrapper').innerHTML = '';
            drawer.querySelector('.video-wrapper').insertAdjacentElement('beforeend', clone);
            if (videoBlock.dataset.type == 'selfhosted') {
              clone.play();
            } else {
              
              player = new YT.Player(clone, {
                videoId: clone.dataset.videoId,
                events: {
                  'onReady': onPlayerReady
                }
              });
              function onPlayerReady(event) {
                event.target.playVideo();
              }
            }
            show(drawer);
            triggerOverlay();
          }
        })
      })
    }
  }
}

// Image Gallery

function imageGallery() {
  const drawer = document.querySelector('.gallery-images-drawer');
  if (drawer) {
    const thumbsWrapper = drawer.querySelector('.thumbs');
    const thumbs = thumbsWrapper.querySelectorAll('.thumb');
    const slider = drawer.querySelector('.product-slider');
    const close = drawer.querySelector('.close');
    const pictures = drawer.closest('.section-wrapper').querySelectorAll('.images-wrapper .image');
    close.addEventListener('click', function() {
      hide(drawer);
      triggerOverlay();
    })
    if (slider) {
      const swiperParams = {
        slidesPerView: 1,
        // autoHeight: 1,
        spaceBetween: 1,
        navigation: {
          nextEl: drawer.querySelector('.next'),
          prevEl: drawer.querySelector('.prev'),
        }
      };
      Object.assign(slider, swiperParams);
      slider.initialize();
    }
    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => {
        slider.swiper.slideTo(index);
      })
    })
    slider.swiper.on('slideChange', function(evt) {
      thumbs.forEach(e => {e.classList.remove('active')});
      const activeThumb = thumbs[this.activeIndex];
      activeThumb.classList.add('active');
      activeThumb.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
    })
    pictures.forEach((e, i) => {
      e.addEventListener('click', () => {
        slider.swiper.slideTo(i);
        show(drawer);
        triggerOverlay();
      })
    })
  }
}

// product mobile drawer

function productMobileDrawer() {
  const button = document.querySelector('.product-info .product-form #AddToCart');
  if (button) {
    setTimeout(function() {
      window.addEventListener('scroll', function(evt) {
        const rect = button.getBoundingClientRect();
        const target = document.querySelector('.product-mobile-drawer');
        const liveChat = document.querySelector('jdiv[class$="jivoMobileButton"] jdiv[class^="button"]');
        
        if (rect.bottom < 0) {
          show(target);
          liveChat ? show(liveChat) : null;
        } else {
          hide(target);
          liveChat ? hide(liveChat) : null;
        }
      })
    }, 2000)
    
  }
}

// Text appear

function textAppear() {
  const blocks = document.querySelectorAll('.text-appear');
  if (blocks.length > 0) {
    blocks.forEach(block => {
      const title = block.querySelector('.appear-title');
      const subtitle = block.querySelector('.appear-subtitle');
      gsap.to(title, {
        scrollTrigger: {
          trigger: title,
          start: '0% 70%',
          // markers: true
        },
        y: 0,
        duration: 2,
        ease: 'power4.out'
      })
      gsap.to(subtitle, {
        scrollTrigger: {
          trigger: subtitle,
          start: '0% 50%',
          // markers: true
        },
        y: 0,
        duration: 2,
        ease: 'power4.out'
      })
    })
  }
}

// Fixed video

function fixedVideo() {
  const blocks = document.querySelectorAll('.fixed-video');
  blocks.forEach(block => {
      const wrapper = block.querySelector('.video-wrapper');
      if (wrapper) {
        const animation = gsap.timeline({
          scrollTrigger: {
            trigger: block.querySelector('.video-wrapper'),
            pinSpacing: false,
            pin: true,
            // markers: true,
            start: 'bottom bottom',
            scrub: 0.5,
            anticipatePin: 1,
            end: () => window.innerWidth > 1024 ? `+=${block.offsetHeight}` : `+=${block.querySelector('video').offsetHeight}`
          } 
        })
      }
  })
}

// map-section

function mapSection() {
  const blocks = document.querySelectorAll('.map-section')
  if (blocks) {
    blocks.forEach(block => {
      const triggers = block.querySelectorAll('.map-container .trigger');
      let object = [];
      triggers.forEach(e => {
        if (e.dataset.country) {
          object.push({
            type: 'country',
            element: block.querySelectorAll(`[data-country="${e.dataset.country}"`),
            name: e.dataset.country
          })
        } else {
          object.push({
            type: 'group',
            element: block.querySelectorAll(`[data-group="${e.dataset.group}"`),
            name: e.dataset.group
          })
        }
      })
      function filterUniqueObjects(array, key) {
        return array.filter((item, index, self) =>
            index === self.findIndex(obj =>
                obj[key] === item[key]
            )
        );
      }
      const countries = filterUniqueObjects(object, 'name').shuffle();
      const timeline = gsap.timeline({ repeat: -1 });
      countries.forEach((box) => {
        timeline.to(box.element, {
          duration: 1.5,
          onStart: () => {
            // console.log(box.element);
            box.element.forEach(e => show(e))
          },
          onComplete: () => {
            box.element.forEach(e => hide(e))
          }
        });
      });

      const numbers = document.querySelector('.numbers');
      if (numbers) {
        const items = numbers.querySelectorAll('.number-wrapper')
        gsap.to(items, {
          scrollTrigger: {
            trigger: numbers,
            start: '20px 70%'
          },
          y: 0,
          opacity: 1,
          ease: 'Expo.easeOut',
          stagger: 0.1,
          onStart: () => {
            const Cont = {val:0};
            let NewVal = 0;
            if (items.length > 0) {
              items.forEach(block => {
                const render = block.querySelector('.digits');
                NewVal = render.innerText;
                TweenLite.to(Cont,3,{val:NewVal,roundProps:"val",onUpdate:function(){
                  render.innerHTML=Cont.val
                }});
              })
            }
          }
        })
      }
    })
  }
}

// footer-accordion

function footerAccordion() {
  const blocks = document.querySelectorAll('.section-footer-main .accordion');
  if (blocks.length > 0) {
    blocks.forEach(block => {
      const items = block.querySelectorAll('.have-childs');
      const active = block.querySelector('.active');
      if (active) {
        active.querySelector('.second-wrapper').style.maxHeight = `${active.querySelector('.second-level').clientHeight}px`;
      }
      items.forEach(item => {
        item.addEventListener('click', function() {
          const currentActive = block.querySelector('.active');
          if (currentActive) {
            if (currentActive === this.parentElement) {
              // console.log('test');
              hide(this.parentElement);
              this.nextElementSibling.style.maxHeight = '0px';
            } else {
              hide(currentActive);
              currentActive.querySelector('.second-wrapper').style.maxHeight = '0px';
              show(this.parentElement);
              this.nextElementSibling.style.maxHeight = `${this.nextElementSibling.querySelector('.second-level').clientHeight}px`;
            }
          } else {
            show(this.parentElement);
            this.nextElementSibling.style.maxHeight = `${this.nextElementSibling.querySelector('.second-level').clientHeight}px`;
          }
        })
      })
      if (window.innerWidth < 768) {
        const mobileMenus = document.querySelectorAll('.section-footer-main .footer-menu');
        mobileMenus.forEach(menu => {
          const button = menu.querySelector('.title');
          button.addEventListener('click', function() {
            if (this.parentElement.classList.contains('active')) {
              hide(this.parentElement);
              this.nextElementSibling.style.maxHeight = '0px';
            } else {
              show(this.parentElement);
              this.nextElementSibling.style.maxHeight = `${this.parentElement.querySelector('.simple-menu').clientHeight}px`;
            }
          })
        })
      }
    })
  }
}

// section product list

function sectionProductList() {
  const sections = document.querySelectorAll('.section-product-list');
  if (sections.length > 0) {
    sections.forEach(section => {
      const slider = section.querySelector('.product-list-slider');
      if (slider) {
        const swiperParams = {
          slidesPerView: 3,
          navigation: {
            nextEl: section.querySelector('.next'),
            prevEl: section.querySelector('.prev'),
          },
          pagination: {
            el: section.querySelector('progress-bar'),
            type: 'progressbar',
          },
          breakpoints: {
            1280: {
              slidesPerView: 4,
              slidesPerGroup: 1,
            },
            768: {
              slidesPerView: 2,
              slidesPerGroup: 1,
            },
            0: {
              slidesPerView: 1.2,
              slidesPerGroup: 1,
            }
          }
        };
        Object.assign(slider, swiperParams);
        slider.initialize();
      }
      

      const insideWrappers = section.querySelectorAll('.images');
      insideWrappers.forEach(insideWrapper => {
        const insideSlider = insideWrapper.querySelector('swiper-container');
        const params = {
          slidesPerView: 1,
          centeredSlides: true,
          navigation: {
            nextEl: insideWrapper.querySelector('.next'),
            prevEl: insideWrapper.querySelector('.prev'),
          }
        };
        Object.assign(insideSlider, params);
        insideSlider.initialize();
      })
    })
  }
}

// section article

function sectionArticle() {
  const share = document.querySelector('.share-button');
  if (share) {
    const buttons = share.nextElementSibling;
    share.addEventListener('click', function() {
      toggle(buttons);
    })
  }
}

// collection banner video

function collectionVideoBanner() {
  const blocks = document.querySelectorAll('.section-video-banner');
  if (blocks.length > 0) {
    blocks.forEach(block => {
      const background = block.querySelector('.background');
      const header = document.querySelector('header');
      window.innerWidth > 1024 ? background.style.maxHeight = `calc(100svh - ${header.clientHeight}px)` : background.style.height = `calc(100svh - ${header.clientHeight}px)`;
      const animation = gsap.timeline({
        scrollTrigger: {
          trigger: block,
          pinSpacing: false,
          pin: true,
          // markers: true,
          start: 'top top',
          scrub: true,
          end: 'bottom top'
        } 
      })
    })
  }
}

// collection filters 

function collectionFilters() {

  let filterData = [];
  let searchParamsInitial = window.location.search.slice(1);
  let searchParamsPrev = window.location.search.slice(1);
  const collection = document.querySelector('.collection-wrapper');
  const staticFilters = document.querySelector('.static-filters');
  const dynamicFilters = document.querySelector('#sidebarFilters');
  filterNavigation();
  setListeners();
  initSliders();
  filterActives();
  switchCollectionView();

  
  if (staticFilters) {
    const inputs = staticFilters.querySelectorAll('input');
    inputs.forEach(input => {
      input.addEventListener('change', function(event) {
        // console.log(event);
        if (input.type == 'checkbox') {
          const targetDynamic = dynamicFilters.querySelector(`#${CSS.escape(this.id.replace('-static', ''))}`);
          if (targetDynamic) {
            targetDynamic.checked = this.checked;
            targetDynamic.form.dispatchEvent(new Event('submit'));
          }
        } else if (input.type == 'range' || input.type == 'number') {
          const targetDynamic = dynamicFilters.querySelector('price-range');
          const currentInputs = input.closest('price-range').querySelectorAll('input');
          const targetInputs = targetDynamic.querySelectorAll('input');
          targetInputs.forEach((targetInput, i) => {
            targetInput.value = currentInputs[i].value;
          })
          // const ranges = targetDynamic.querySelector('.range-group');
          // const inputs = targetDynamic.querySelector('.inputs-wrapper');
          // ranges.querySelector(`[data-id="${input.dataset.id}"]`).value = input.value;
          // inputs.querySelector(`[data-id="${input.dataset.id}"]`).value = input.value;
          targetDynamic.closest('form').dispatchEvent(new Event('submit'));
        }        
      })
    })
  }

  if (dynamicFilters) {
    const inputs = dynamicFilters.querySelectorAll('input');
    inputs.forEach(input => {
      input.addEventListener('change', function(event) {
        this.form.dispatchEvent(new Event('submit'));
      })
    })
    dynamicFilters.addEventListener('submit', function(event) {
      event.preventDefault();
      event.stopPropagation();
      let searchParams = createSearchParams(this);
      const searchForm = document.querySelector('#mainSearch')
      if (searchForm) {
        const paramsForSearch = createSearchParams(searchForm);
        searchParams += `&${paramsForSearch}`;
        // console.log(searchParams);
      }
      // updateURLHash(searchParams);
      // console.log('WORKS');
      renderPage(searchParams, event);
    })
    // inputs.forEach(input => {
    //   input.addEventListener('change', function(event) {
    //     this.form.dispatchEvent(new Event('submit'));
    //   })
    // })
  }

  function initSliders() {
    if (collection) {
      const insideWrappers = collection.querySelectorAll('.images');
      insideWrappers.forEach(insideWrapper => {
        const insideSlider = insideWrapper.querySelector('swiper-container');
        const params = {
          slidesPerView: 1,
          navigation: {
            nextEl: insideWrapper.querySelector('.next'),
            prevEl: insideWrapper.querySelector('.prev'),
          }
        };
        insideSlider ? (Object.assign(insideSlider, params), insideSlider.initialize() ) : null;
      })
    }
    
  }

  function createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  function updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  function setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : searchParamsInitial;
      if (searchParams === searchParamsPrev) return;
      renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  function renderPage(searchParams, event, updateHash = true) {
    searchParamsPrev = searchParams;
    collection.classList.add('loading');
    const url = `${window.location.pathname}?section_id=${collection.dataset.id}&${searchParams}`;
    const filterDataUrl = (element) => element.url === url;

    filterData.some(filterDataUrl)
      ? renderSectionFromCache(filterDataUrl, event)
      : renderSectionFromFetch(url, event);

    if (updateHash) updateURLHash(searchParams);
    
  }

  function renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        filterData = [...filterData, { html, url }];
        renderCollection(html);
        renderFilters(html);
        updateActives(html);
        collection.classList.remove('loading');
      });
  }

  function renderSectionFromCache(filterDataUrl, event) {
    const html = filterData.find(filterDataUrl).html;
    renderCollection(html);
    renderFilters(html);
    updateActives(html);
    collection.classList.remove('loading');
  }

  function updateActives(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const actives = parsedHTML.querySelector('.active-facets');
    document.querySelector('.active-facets').innerHTML = actives.innerHTML;
  }

  function renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    // static area
    const staticBoxes = parsedHTML.querySelectorAll('.static-filters .filter-group');
    staticBoxes.forEach(box => {
      const target = staticFilters.querySelector(`#${box.id}`);
      target.querySelector('button').innerHTML = box.querySelector('button').innerHTML;
      const boxes = target.querySelectorAll('.selector-box');
      boxes.forEach((trBox, index) => {
        const inputs = trBox.querySelectorAll('input');
        const incomingInputs = box.querySelectorAll('input');
        const counts = trBox.querySelectorAll('.values-count');
        const incomingCounts = box.querySelectorAll('.values-count');
        inputs.forEach((input, i) => {
          if (input.type === 'checkbox') {
            input.checked = incomingInputs[i].checked;
            input.disabled = incomingInputs[i].disabled;
            input.value = incomingInputs[i].value;
          } else {
            input.value = incomingInputs[i].value;
            const incomingRange = box.querySelector('.range-group');
            trBox.querySelector('.range-group').style.setProperty('--range-min', incomingRange.style.getPropertyValue('--range-min'));
            trBox.querySelector('.range-group').style.setProperty('--range-max', incomingRange.style.getPropertyValue('--range-max'));
          }
        })
        counts.forEach((e,i) => {e.innerHTML = incomingCounts[i].innerHTML})
      })
    })
    // dynamic area
    const dynamicBoxes = parsedHTML.querySelectorAll('.sidebar-filters .filter-group');
    dynamicBoxes.forEach((box, index) => {
      const target = dynamicFilters.querySelectorAll('.filter-group')[index];
      if (target) {
        target.querySelector('button').innerHTML = box.querySelector('button').innerHTML;
        const boxes = target.querySelectorAll('.selector-box');
        boxes.forEach((trBox) => {
          const inputs = trBox.querySelectorAll('input');
          const incomingInputs = box.querySelectorAll('input');
          const counts = trBox.querySelectorAll('.values-count');
          const incomingCounts = box.querySelectorAll('.values-count');
          inputs.forEach((input, i) => {
            if (input.type === 'checkbox') {
              input.checked = incomingInputs[i].checked;
              input.disabled = incomingInputs[i].disabled;
              input.value = incomingInputs[i].value;
            } else {
              input.value = incomingInputs[i].value;
              const incomingRange = box.querySelector('.range-group');
              trBox.querySelector('.range-group').style.setProperty('--range-min', incomingRange.style.getPropertyValue('--range-min'));
              trBox.querySelector('.range-group').style.setProperty('--range-max', incomingRange.style.getPropertyValue('--range-max'));
            }
          })
          counts.forEach((e,i) => {e.innerHTML = incomingCounts[i].innerHTML})
        })
      }
    })
    const bottomWrapper = parsedHTML.querySelector('.bottom-wrapper');
    if (bottomWrapper) {
      const incomingButton = bottomWrapper.querySelector('button');
      const button = dynamicFilters.querySelector('.bottom-wrapper .button');
      button.innerHTML = incomingButton.innerHTML;
    }
  }

  function renderCollection(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const incomingData = parsedHTML.querySelector('.collection-wrapper');
    const incomingButton = parsedHTML.querySelector('.top-elements .filter-button');
    const incomingPagination = parsedHTML.querySelector('.pagination-wrapper');
    document.querySelector('.top-elements .filter-button').innerHTML = incomingButton.innerHTML;
    document.querySelector('.pagination-wrapper').innerHTML = incomingPagination.innerHTML;

    collection.innerHTML = incomingData.innerHTML;
    initSliders();
  }

  function filterNavigation() {
    if (dynamicFilters) {
      const dynamicButtons = dynamicFilters.querySelectorAll('.filter-label-button');
      const staticButtons = staticFilters.querySelectorAll('[data-id="staticButton"]');
      const prevs = dynamicFilters.querySelectorAll('.prev');
      const closes = dynamicFilters.querySelectorAll('.close');
      const wrapper = dynamicFilters.querySelector('.sidebar-filters-wrapper');
      const drawerButton = staticFilters.querySelector('.filter-side-button');
      const mobileDrawer = document.querySelector('.top-elements .filter-button');
      drawerButton.addEventListener('click', function() {
        show(dynamicFilters);
        triggerOverlay();
      })
      mobileDrawer.addEventListener('click', function() {
        show(dynamicFilters);
        triggerOverlay();
      })
      staticButtons.forEach(button => {
        button.addEventListener('click', function() {
            if (button.classList.contains('active')) {
              hide(button);
              hide(button.nextElementSibling);
            } else {
              staticButtons.forEach(e => {
                hide(e);
                hide(e.nextElementSibling);
              })
              show(button.nextElementSibling);
              show(this);
            }
            
        })
      })
      dynamicButtons.forEach(button => {
        button.addEventListener('click', function() {
          show(wrapper);
          show(this.nextElementSibling);
        })
      })
      prevs.forEach(prev => {
        prev.addEventListener('click', function() {
          hide(wrapper);
          hide(this.closest('.selector-box'));
        })
      })
      closes.forEach(close => {
        close.addEventListener('click', function() {
          // console.log('close');
          hide(wrapper);
          hide(dynamicFilters);
          triggerOverlay();
        })
      })
    }
  }

  var PriceRange = class extends HTMLElement {
    connectedCallback() {
      this._abortController = new AbortController();
      this.rangeLowerBound = this.querySelector('input[type="range"]:first-child');
      this.rangeHigherBound = this.querySelector('input[type="range"]:last-child');
      this.textInputLowerBound = this.querySelector('input[name="filter.v.price.gte"]');
      this.textInputHigherBound = this.querySelector('input[name="filter.v.price.lte"]');
      this.textInputLowerBound.addEventListener("focus", () => this.textInputLowerBound.select(), { signal: this._abortController.signal });
      this.textInputHigherBound.addEventListener("focus", () => this.textInputHigherBound.select(), { signal: this._abortController.signal });
      this.textInputLowerBound.addEventListener("change", (event) => {
        event.preventDefault();
        event.target.value = Math.max(Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1), event.target.min);
        this.rangeLowerBound.value = event.target.value;
        this.rangeLowerBound.parentElement.style.setProperty("--range-min", `${parseInt(this.rangeLowerBound.value) / parseInt(this.rangeLowerBound.max) * 100}%`);
      }, { signal: this._abortController.signal });
      this.textInputHigherBound.addEventListener("change", (event) => {
        event.preventDefault();
        event.target.value = Math.min(Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1), event.target.max);
        this.rangeHigherBound.value = event.target.value;
        this.rangeHigherBound.parentElement.style.setProperty("--range-max", `${parseInt(this.rangeHigherBound.value) / parseInt(this.rangeHigherBound.max) * 100}%`);
      }, { signal: this._abortController.signal });
      this.rangeLowerBound.addEventListener("change", (event) => {
        event.stopPropagation();
        this.textInputLowerBound.value = event.target.value;
        this.textInputLowerBound.dispatchEvent(new Event("change", { bubbles: true }));
      }, { signal: this._abortController.signal });
      this.rangeHigherBound.addEventListener("change", (event) => {
        event.stopPropagation();
        this.textInputHigherBound.value = event.target.value;
        this.textInputHigherBound.dispatchEvent(new Event("change", { bubbles: true }));
      }, { signal: this._abortController.signal });
      this.rangeLowerBound.addEventListener("input", (event) => {
        event.target.value = Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1);
        event.target.parentElement.style.setProperty("--range-min", `${parseInt(event.target.value) / parseInt(event.target.max) * 100}%`);
        this.textInputLowerBound.value = event.target.value;
      }, { signal: this._abortController.signal });
      this.rangeHigherBound.addEventListener("input", (event) => {
        event.target.value = Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1);
        event.target.parentElement.style.setProperty("--range-max", `${parseInt(event.target.value) / parseInt(event.target.max) * 100}%`);
        this.textInputHigherBound.value = event.target.value;
      }, { signal: this._abortController.signal });
    }
    disconnectedCallback() {
      this._abortController.abort();
    }
  };
  if (!window.customElements.get("price-range")) {
    window.customElements.define("price-range", PriceRange);
  }

  function filterActives() {
    window.addEventListener('click', function(event) {
      if (event.target.dataset.action === 'clear-filters') {
        if (!this.document.querySelector('#mainSearch')) {
          event.preventDefault();
          const url = new URL(event.target.href);
          const searchParams = url.searchParams.toString();
          renderPage(searchParams, event);
        } else {
          event.preventDefault();
          const url = new URL(event.target.href);
          const form = this.document.querySelector('#mainSearch');
          const searchParams = createSearchParams(form);
          renderPage(searchParams, event);
        }
      }
    })
  }

  function switchCollectionView() {
    if (collection) {
      collection.dataset.view = localStorage.getItem('collectionView') ? localStorage.getItem('collectionView') : 'triple';
      const viewSwitchers = document.querySelectorAll('.view-switcher .button');
      if (viewSwitchers.length > 0) {
        viewSwitchers.forEach(e => {
          e.dataset.switch === collection.dataset.view ? show(e) : hide(e);
          e.addEventListener('click', function() {
            viewSwitchers.forEach(el => hide(el));
            show(e);
            collection.dataset.view = e.dataset.switch;
            localStorage.setItem('collectionView', e.dataset.switch);
            // console.log(localStorage.getItem('collectionView'));
          })
        })
      }
    }
  }
}



// cart drawer

function renderDrawerCart(html) {
  const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
  const incomingCart = parsedHTML.querySelector('.main-cart-drawer .whole-wrapper');
  const incomingScript = incomingCart.querySelector('script');
    
  const cart = document.querySelector('.main-cart-drawer .whole-wrapper');
  if (incomingScript) {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.text = incomingScript.innerHTML;
    cart.insertBefore(script, cart.firstChild);
  }
  cart.innerHTML = incomingCart.innerHTML;
}

function renderHead(html) {
  const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
  const incomingHead = parsedHTML.querySelector('.cart');
  const head = document.querySelector('.header-secondary .cart');
  head.innerHTML = incomingHead.innerHTML;
}

function cartDrawer() {

  const drawer = document.querySelector('.cart-drawer-wrapper');
  const close = drawer.querySelector('.close');
  const checkout = drawer.querySelector('.button-checkout');
  if (checkout) {
    checkout.addEventListener('click', function() {
      drawer.querySelector('form').submit();
    })
  }
  
  close.addEventListener('click', function() {
    hide(drawer.closest('.main-cart-drawer'));
    triggerOverlay();
  })

  renderRelated();
  // recommendations
  function renderRelated() {
    if (window.ISCartItems && window.ISCartItems.length > 0) {
      const section = document.querySelector('.main-cart-drawer .recommendations');
      // console.log(window.ISCartItems);    
      let recommendations = [];
      let uniqueRecommendationIds = new Set();
      const sectionId = document.querySelector('#mainCart') ? 'cart-static-recommendations' : 'cart-recommendations';
      let fetchPromises = window.ISCartItems.map(item => {
      return fetch(window.Shopify.routes.root + `recommendations/products?product_id=${item}&limit=10&section_id=${sectionId}&intent=related`)
        .then(response => response.text())
        .then((text) => {
            const parsedHTML = new DOMParser().parseFromString(text, 'text/html');
            const elements = parsedHTML.querySelectorAll('.recommendation-product');
            elements.forEach(e => {
              const productId = e.getAttribute('data-id');
              if (productId && !uniqueRecommendationIds.has(productId) && !window.ISCartItems.includes(productId)) {
                uniqueRecommendationIds.add(productId);
                recommendations.push(e);
              }
            });
        });
      });
  
      Promise.all(fetchPromises)
      .then(() => {
        // console.log(recommendations);
        const div = document.createElement('div');
        recommendations.forEach(e => {
          div.appendChild(e);
        })
        if (section) {
          section.innerHTML = '';
          section.innerHTML = div.innerHTML;
          if (recommendations.length === 0) {
            section.closest('.recommendations-wrapper').style.display = 'none';
          }
          if (document.querySelector('#mainCart')) {
            const section = document.querySelector('#mainCart .recommendations');
            if (recommendations.length === 0) {
              section.closest('.recommendations-wrapper').style.display = 'none';
            } else {
              section.innerHTML = div.innerHTML;
            }
          }
        }
      })
      .catch(error => {
        console.error('Error fetching recommendations:', error);
      });
    }
  }
  
  

  // active links in drawer with section rendering

  window.addEventListener('click', function(evt) {
    if (evt.target.hasAttribute('data-render-section')) {
      evt.preventDefault();
      const sectionId = evt.target.closest('.main-cart-drawer').id;
      const loading = evt.target.closest('.main-cart-drawer').querySelector('.loading');
      loading.style.display = 'block';
      let url = new URL(evt.target.href);
      let params = new URLSearchParams(url.search);
      params.set('section_id', sectionId);
      url.search = params.toString();
      url = url.toString();
      fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        renderDrawerCart(html);
        renderHead(html);
        renderRelated();
        loading.style.display = 'none';
      });
    }

    if (evt.target.hasAttribute('data-related-add')) {
      hide(evt.target.querySelector('.icon'));
      show(evt.target.querySelector('.spinner'));
      let formData = {
        'items': [{
         'id': evt.target.dataset.id,
         'quantity': 1
         }]
       };
      const url = window.Shopify.routes.root + 'cart/add.js';
      let loading;
      if (!this.document.querySelector('#mainCart')) {
        loading = evt.target.closest('.main-cart-drawer').querySelector('.loading');
        loading.style.display = 'block';
      }
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then((res) => {return res.json()})
      .then((data) => {
        if (document.querySelector('#mainCart')) {
          window.location.reload();
        } else {
          fetch(window.Shopify.routes.root + 'cart')
          .then((response) => response.text())
          .then((responseText) => {
            const html = responseText;
            renderDrawerCart(html);
            renderHead(html);
            renderRelated();
            loading.style.display = 'none';
          });
        }
      })
    }

    if (evt.target.id === 'BuyGiftKit') {
      // console.log(evt.target.dataset.giftId);
      hide(evt.target.querySelector('.icon'));
      show(evt.target.querySelector('.spinner'));
      let formData = {
        'items': [
          {
            'id': evt.target.dataset.id,
            'quantity': 1
          },
          {
            'id': evt.target.dataset.giftId,
            'quantity': 1
          }
        ]
      };
      const url = window.Shopify.routes.root + 'cart/add.js';
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then((res) => {return res.json()})
      .then((data) => {
        fetch(window.Shopify.routes.root + 'cart')
        .then((response) => response.text())
        .then((responseText) => {
          const html = responseText;
          renderDrawerCart(html);
          renderHead(html);
          renderRelated();
          show(drawer.closest('.main-cart-drawer'));
          triggerOverlay();
          show(evt.target.querySelector('.icon'));
          hide(evt.target.querySelector('.spinner'));
        });
      })
    }

    if (evt.target.hasAttribute('data-collection-add')) {
      hide(evt.target.querySelector('.icon'));
      show(evt.target.querySelector('.spinner'));
      let formData = {
        'items': [{
         'id': evt.target.dataset.id,
         'quantity': 1
         }]
       };
      const url = window.Shopify.routes.root + 'cart/add.js';
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then((res) => {return res.json()})
      .then((data) => {
        // console.log(data);
        fetch(window.Shopify.routes.root + 'cart')
        .then((response) => response.text())
        .then((responseText) => {
          const html = responseText;
          renderDrawerCart(html);
          renderHead(html);
          renderRelated();
          show(drawer.closest('.main-cart-drawer'));
          triggerOverlay();
          show(evt.target.querySelector('.icon'));
          hide(evt.target.querySelector('.spinner'));
        });
      })
    }

    if (evt.target.hasAttribute('data-cart-bubble')) {
      const count = parseInt(evt.target.querySelector('span').dataset.count);
      if (count > 0 && !document.querySelector('#mainCart')) {
        show(drawer.closest('.main-cart-drawer'));
        triggerOverlay();
      }
    }
  })
}

// consultation-drawer

function consultationDrawer() {
  const drawer = document.querySelector('.consultation-drawer');
  if (drawer) {
    const close = drawer.querySelector('.close');
    close.addEventListener('click', function() {
      hide(drawer);
      triggerOverlay();
    })
    window.addEventListener('click', function(evt) {
      if (evt.target.hasAttribute('data-consultation')) {
        evt.preventDefault();
        show(drawer);
        triggerOverlay();
      }
    })
  }
}

function dynamicDrawer() {
  
  const buttons = document.querySelectorAll(`a[href^="#dynamicDrawer-"]`);
  if (buttons.length > 0) {
    buttons.forEach(button => {
      const id = button.href.split('#')[1];
      const drawer = document.querySelector(`#${id}`)?.parentElement;
      // console.log(drawer);
      
      if (drawer) {
        const close = drawer.querySelector('.close');
        close.addEventListener('click', function() {
          hide(drawer);
          triggerOverlay();
        })
        button.addEventListener('click', function(evt) {
          evt.preventDefault();
          show(drawer);
          triggerOverlay();
        })
      }
    })
  }
}

function specificationDrawer() {
  const button = document.querySelector(`[data-specs-drawer]`);
  const drawer = document.querySelector(`#main-specs-drawer`);
  if (button && drawer) {
    button.addEventListener('click', function(evt) {
      evt.preventDefault();
      show(drawer);
      triggerOverlay();
    })
    const close = drawer.querySelector('.close');
    close.addEventListener('click', function() {
      hide(drawer);
      triggerOverlay();
    })
  }
}

// market drawers

function marketDrawers() {
  const drawers = ['.delivery-drawer', '.payment-drawer'];
  drawers.forEach(e => {
    const drawer = document.querySelector(e);
    if (drawer) {
      const close = drawer.querySelector('.close')
      close.addEventListener('click', function() {
        hide(drawer);
        triggerOverlay();
      })
      window.addEventListener('click', function(evt) {
        if (evt.target.hasAttribute('data-market-drawer')) {
          const popup = evt.target.closest('.sibling').nextElementSibling;
          show(popup);
          triggerOverlay();
        }
      })
    }
  })
}

// sliding cards

function slidingCards() {
  const blocks = document.querySelectorAll('.section-sliding-cards');
  if (blocks.length > 0) {
    blocks.forEach(block => {
      const cards = block.querySelectorAll('.content-item');
      cards.forEach(card => {
        gsap.set(card, {
          opacity: 0,
          x: '-100%'
        })
        ScrollTrigger.create({
          trigger: card,
          start: "top 80%",
          onEnter: () => gsap.to(card, { 
            opacity: 1, 
            x: 0, 
            duration: 1.5,
            ease: 'power4.out'
          }),
          scrub: true
      });
      })
    })
  }
}

// search

function predictiveSearch() {
  class PredictiveSearch extends HTMLElement {
    constructor() {

      super();
      this.input = this.querySelector('input[type="text"]');
      this.predictiveSearchResults = this.parentElement.querySelector('.search-results');
      this.suggestions = this.parentElement.querySelector('.suggestions');
      this.erase = this.querySelector('.erase');
      this.closeButton = this.parentElement.parentElement.querySelector('.close');
      this.trigger = document.querySelector('#searchOpen');
      this.predictiveSearchResults.style.display = 'none';
      this.input.addEventListener('input', this.debounce((event) => {
        this.input.value.length > 0 ? show(this.erase) : hide(this.erase);
        this.onChange(event);
      }, 300).bind(this));
      this.erase.addEventListener('click', () => {
        this.input.value = '';
        hide(this.erase);
        setTimeout(() => {
          this.input.focus();
        }, 100);
        this.close();
      })
      this.closeButton.addEventListener('click', () => {
        hide(this.closest('.search-drawer'));
        triggerOverlay();
      })
      this.trigger.addEventListener('click', () => {
        if (!document.querySelector('#mainSearch')) {
          // const inputField = this.closest('.search-drawer').querySelector('form input');
          setTimeout(() => {
            this.input.focus();
          }, 100);
          show(this.closest('.search-drawer'));
          triggerOverlay();
        }
      })
    }

    
  
    onChange() {
      const searchTerm = this.input.value.trim();
  
      if (!searchTerm.length) {
        this.close();
        return;
      }
  
      this.getSearchResults(searchTerm);
    }
  
    getSearchResults(searchTerm) {
      fetch(`${Shopify.routes.root}search/suggest?q=${searchTerm}&resources[options][unavailable_products]=show&resources[type]=product,collection&section_id=predictive-search`)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
          }
  
          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
          this.predictiveSearchResults.innerHTML = resultsMarkup;
          this.open();
        })
        .catch((error) => {
          this.close();
          throw error;
        });
    }
  
    open() {
      this.predictiveSearchResults.style.display = 'flex';
      this.suggestions.style.display = 'none';
    }
  
    close() {
      this.predictiveSearchResults.style.display = 'none';
      this.suggestions.style.display = 'flex';
    }
  
    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }
  customElements.define('predictive-search', PredictiveSearch);
}

function productGiftSelect() {
  const block = document.querySelector('.gifts-selector');
  if (block) {
    const cardBlock = block.closest('.product-card');
    const sectionBlock = cardBlock.closest('.gifts-wrapper');
    const button = cardBlock.querySelector('.gift-button');
    if (button) {
      button.addEventListener('click', () => {
        toggle(block);
      })
    }
    const gifts = block.querySelectorAll('.gift-value');
    const giftImage = cardBlock.querySelector('.product-image');
    const giftTitle = cardBlock.querySelector('.s4');
    const messageTitle = sectionBlock.querySelector('.right-part .h5 .gift_title');
    const kitButton = sectionBlock.querySelector('.right-part .button-short-buy');
    gifts.forEach(gift => {
      gift.addEventListener('click', function(evt) {
        const image = evt.target.querySelector('.image');
        const title = evt.target.querySelector('.title');
        giftImage.innerHTML = image.innerHTML;
        giftTitle.innerHTML = title.innerHTML;
        messageTitle.innerHTML = title.innerHTML;
        kitButton.dataset.giftId = evt.target.dataset.id;
        hide(block);
      })
    })
  }
  const buyGiftButton = document.querySelector('#BuyGiftKit');
  if (buyGiftButton) {
    buyGiftButton.addEventListener('click', function(evt) {
      
    })
  }
}

// delegated events

window.addEventListener('click', function(evt) {

  // lang switcher

  

  // featured collections section

  if (evt.target.dataset.id === 'featColTrigger') {
    const currentButton = evt.target.parentElement.querySelector('.active');
    const currentSection = evt.target.parentElement.nextElementSibling.querySelector('.active');
    const targetButton = evt.target;
    const targetSection = evt.target.parentElement.nextElementSibling.querySelector(`#section-${targetButton.dataset.index}`);
    if (currentButton != targetButton) {
      hide(currentButton);
      hide(currentSection);
      show(targetButton);
      show(targetSection);
    }
  }

  if (evt.target.dataset.id !== 'shareButtons') {
    const shareButtons = document.querySelector('.share-buttons');
    shareButtons ? hide(shareButtons) : null;
  }

  if (document.querySelector('#staticFilters')) {
    if (!evt.target.closest('.filter-group')) {
      this.document.querySelectorAll('[data-id="staticButton"]').forEach(e => {
        hide(e);
        hide(e.nextElementSibling);
      })
    }
  }

  if (!evt.target.closest('.localization-box')) {
    this.document.querySelectorAll('.localization-box .select-button').forEach(e => {
      hide(e);
      hide(e.nextElementSibling);
    })
  }

  if (this.document.querySelector('#giftSelector')) {
    if (!evt.target.closest('#giftSelector') && !evt.target.closest('#giftButton')) {
      hide(this.document.querySelector('#giftSelector'));
    }
  }
  

})


